module.exports = __webpack_public_path__ + "img/badge-sheriff.f0c777a5.svg";